import { useState } from 'react';
import { ChevronRight } from 'lucide-react';

import { Markdown } from '~/components/CustomMarkdown';
import { Button } from '~/components/ui/button';
import { cn } from '~/lib/utils';

interface Props {
  description: string;
  eventName: string;
}

const MAX_LENGTH = 300;

export function EventDescription({ description, eventName }: Props) {
  const [isExpanded, setIsExpanded] = useState(false);

  const shouldTruncate = description.length > MAX_LENGTH;

  return (
    <>
      <div className="text-sm mt-4 max-w-none text-muted-foreground">
        <div className={cn(shouldTruncate && !isExpanded && 'line-clamp-3')}>
          <Markdown>{description}</Markdown>
        </div>
      </div>
      {shouldTruncate && !isExpanded && (
        <div className="mt-2">
          <button
            className="flex items-center text-sm gap-1 px-0 h-auto font-normal mt-2 text-primary hover:underline cursor-pointer"
            onClick={() => setIsExpanded(true)}
          >
            Learn more about {eventName} <ChevronRight size={14} />
          </button>
        </div>
      )}
    </>
  );
}
